interface GenerateOptions {
    nombreCiblesParCases: number;
  }
  
  export const generateZoneFrontiereTargets = (
    cases: { [key: string]: string[] },
    options: GenerateOptions
  ): string[] => {
    const ZF = cases["ZF"];
    const targets: string[] = [];
  
    // Repeat each position in ZF according to nombreCiblesParCases
    ZF.forEach(position => {
      for (let i = 0; i < options.nombreCiblesParCases; i++) {
        targets.push(position);
      }
    });
  
    // Shuffle the targets array
    for (let i = targets.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [targets[i], targets[j]] = [targets[j], targets[i]];
    }
  
    return targets;
  };